/**
 * siteConfig — ChatsPulse standalone fork.
 *
 * The parent monorepo carried 20+ site profiles; this fork is
 * hard-locked to a single one. The resolveSiteSlug/siteProfile/
 * redirectForHost API is preserved so any legacy component that
 * still imports it keeps working.
 */

export const SITE_PROFILES = {
  chatspulse: {
    slug:        "chatspulse",
    label:       "ChatsPulse",
    hideNav:     null,
    portalSections: null,
    defaultLang: "en",
    countryPref: null,
    accent:      "#2563eb",
  },
};

export const HOST_REDIRECTS = {};

export function redirectForHost() {
  return null;
}

export function resolveSiteSlug() {
  return "chatspulse";
}

export function siteProfile() {
  return SITE_PROFILES.chatspulse;
}

export function isNavHidden() {
  return false;
}

export function isPortalSectionAllowed() {
  return true;
}
